import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import ContainerPage from '../../components/ContainerPage/ContainerPage'
import PageTitle from '../../components/PageTitle/PageTitle'
import TableFooter from '../../components/Pagination/TableFooter'
import DebounceInput from '../../components/DebouncedSearch/DebouncedSearch'
import Button from '../../components/Button/Button'
import Dropdown from '../../components/Dropdown/Dropdown'
import { showSnackBar } from '../../components/Snackbar/Snackbar'
import { useMyContextLoading } from '../../components/LoadingContextProvider/LoadingContextProvider'
import { TABLE_CARD } from '../../components/Table/tableCardClass'
import PlusIcon from '../../assets/images/icons/PlusIcon.svg'
import { fetchAffiliates } from '../../features/affiliates/affiliates'
import { AFFILIATE_STATUS_OPTIONS } from '../Affiliates/affiliateStatus'
import MyTeamTable from './MyTeamTable'

const STATUS_FILTER_OPTIONS = [
  { value: '', label: 'All Statuses' },
  ...AFFILIATE_STATUS_OPTIONS,
]

const MyTeam = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { triggerBar } = useMyContextLoading()
  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(10)
  const [search, setSearch] = useState('')
  const [affiliateStatus, setAffiliateStatus] = useState('')
  const [team, setTeam] = useState({ affiliates: [], pageCount: '', totalCount: null })

  const loadTeam = useCallback(async () => {
    triggerBar(true)
    const response = await dispatch(fetchAffiliates({
      limit,
      offset: (page - 1) * limit,
      searchQuery: search,
      affiliateStatus: affiliateStatus || undefined,
    }))
    if (response.error) {
      showSnackBar('error', response.payload || 'Failed to load your team')
    } else {
      setTeam({
        affiliates: response.payload?.data?.affiliates || [],
        pageCount: response.payload?.data?.meta?.pageCount,
        totalCount: response.payload?.data?.meta?.totalAffiliates,
      })
    }
    triggerBar(false)
  }, [dispatch, triggerBar, limit, page, search, affiliateStatus])

  useEffect(() => {
    loadTeam()
  }, [loadTeam])

  return (
    <ContainerPage>
      <div className="flex justify-between items-center">
        <PageTitle title="My Team" />
        <Button classes="flex h-9 items-center gap-2" onClick={() => navigate('/my-team/add')}>
          <img src={PlusIcon} alt="" />
          <span>Add Member</span>
        </Button>
      </div>
      <div className={`${TABLE_CARD} mt-6`}>
        <div className="flex flex-row items-center px-5 py-4">
          <DebounceInput
            customClassName="mr-5 b-1"
            value={search}
            setSearchValue={(value) => {
              setSearch(value || '')
              setPage(1)
            }}
            placeholder="Search..."
          />
          <Dropdown
            medium
            value={affiliateStatus}
            setValue={(value) => {
              setAffiliateStatus(value)
              setPage(1)
            }}
            menuItems={STATUS_FILTER_OPTIONS}
            className="w-[180px]"
            placeholder="All Statuses"
          />
        </div>
        <MyTeamTable data={team.affiliates} onChanged={loadTeam} />
        <TableFooter
          page={page}
          limit={limit}
          total={team.totalCount}
          pageCount={team.pageCount}
          setPage={setPage}
          setLimit={(newLimit) => {
            setLimit(newLimit)
            setPage(1)
          }}
        />
      </div>
    </ContainerPage>
  )
}

export default MyTeam
